import { lazy } from "react";

const AMap = lazy(() => import(/* webpackChunkName: 'amap' */ "../pages/AMap"));
const Index = lazy(() =>
	import(/* webpackChunkName: 'amap' */ "../pages/Index")
);
const Message = lazy(() =>
	import(/* webpackChunkName: 'msg' */ "../pages/Message")
);
const Bing = lazy(() =>
	import(/* webpackChunkName: 'bing' */ "../pages/Bing")
);
const Feedback = lazy(() =>
	import(/* webpackChunkName: 'feedback' */ "../pages/Feedback")
);

const routes = [
	{
		path: "/",
		component: () => <Index />,
	},
	{
		path: "/app/amap",
		component: () => <AMap />,
	},
	{
		path: "/app/message",
		component: () => <Message />,
	},
	{
		path: "/app/bing",
		component: () => <Bing />,
	},
	{
		path: "/app/feedback",
		component: () => <Feedback />,
	},
];

export default routes;
